import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Stars } from "@/components/admin/ui";
import { CheckCircle2 } from "lucide-react";

export default function Feedback() {
  const { sid } = useParams();
  const { user } = useAuth();
  const [store, setStore] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => { api.get("/stores").then((r) => setStore(r.data.find((s) => s.id === sid) || null)); }, [sid]);
  useEffect(() => { if (user) { setEmail(user.email || ""); setName(user.name || ""); } }, [user]);

  const submit = async () => {
    if (!rating) return setErr("Please tap a star rating.");
    try { await api.post("/feedback", { store_id: sid, rating, comment, email, name }); setDone(true); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-lg mx-auto px-6 py-16">
      <p className="eyebrow mb-2">{store?.name || "Sandar Sushi"}</p>
      <h1 className="font-display font-bold text-4xl tracking-tight mb-2" data-testid="feedback-page-title">How was your experience?</h1>
      {done ? (
        <div className="mt-8 rounded-2xl bg-emerald-50 border border-emerald-100 p-6 text-center" data-testid="feedback-thanks">
          <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto mb-2"/>
          <p className="font-semibold">Thank you! Your feedback helps us get better.</p>
          <Link to="/menu" className="text-sm text-[hsl(var(--primary))] underline mt-2 inline-block">Browse the menu</Link>
        </div>
      ) : (
        <div className="mt-6 space-y-4">
          <div className="py-2"><Stars value={rating} onChange={setRating} size="w-10 h-10"/></div>
          <Textarea rows={4} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Tell us more (optional)" data-testid="feedback-comment"/>
          <div className="grid sm:grid-cols-2 gap-3">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)" data-testid="feedback-name"/>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email (optional)" data-testid="feedback-email"/>
          </div>
          {err && <p className="text-sm text-red-600" data-testid="feedback-error">{err}</p>}
          <Button onClick={submit} className="w-full h-12 rounded-full bg-[hsl(var(--primary))] text-base" data-testid="feedback-submit">Send Feedback</Button>
        </div>
      )}
    </div>
  );
}
